<template>
  <div id="modul-material">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/modul-belajar'}">Modul Belajar</router-link>
      </li>
      <li>
        <router-link :to="{path: '/modul-belajar/form'}">Informasi Umum</router-link>
      </li>
      <li class="active">Materi</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Kelola Materi</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="createMaterial()"><span class="fa fa-plus"></span> Tambah Materi</button>
            </div>
            <h4 class="panel-title">Daftar Materi</h4>
          </div>
          <div class="panel-body">
            <div class="col-md-12">
              <button class="btn btn-sm m-r-5" v-bind:class="{'btn-inverse': jenjang == 'SD'}" @click="jenjang = 'SD'">SD</button>
              <button class="btn btn-sm m-r-5" v-bind:class="{'btn-inverse': jenjang == 'SMP'}" @click="jenjang = 'SMP'">SMP</button>
              <button class="btn btn-sm m-r-5" v-bind:class="{'btn-inverse': jenjang == 'SMA'}" @click="jenjang = 'SMA'">SMA</button>
            </div><hr />
            <div class="col-md-12">
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 1}" @click="kelas = 1">1</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 2}" @click="kelas = 2">2</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 3}" @click="kelas = 3">3</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 4}" @click="kelas = 4">4</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 5}" @click="kelas = 5">5</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SD'" v-bind:class="{'btn-inverse': kelas == 6}" @click="kelas = 6">6</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMP'" v-bind:class="{'btn-inverse': kelas == 7}" @click="kelas = 7">7</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMP'" v-bind:class="{'btn-inverse': kelas == 8}" @click="kelas = 8">8</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMP'" v-bind:class="{'btn-inverse': kelas == 9}" @click="kelas = 9">9</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMA'" v-bind:class="{'btn-inverse': kelas == 10}" @click="kelas = 10">10</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMA'" v-bind:class="{'btn-inverse': kelas == 11}" @click="kelas = 11">11</button>
              <button class="btn btn-sm m-r-5" v-if="jenjang == 'SMA'" v-bind:class="{'btn-inverse': kelas == 12}" @click="kelas = 12">12</button>
            </div><hr />
            <app-datatable :headers="headers" :items="rows" v-on:selected="selectedRow = $event" :has-preview="true" v-on:dblClicked="editMaterial()" v-on:deleted="deleteItem($event)"></app-datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/plugins/DataTable'
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'
import VideoService from '@/services/video.js'
import Moment from 'moment'

export default {
  name: 'modul-material',
  components: {
    'app-datatable': DataTable,
    'app-modal': Modal,
    'app-spinner': Spinner
  },
  data: function () {
    return {
      isLoading: false,
      showModal: false,
      modul: null,
      jenjang: 'SD',
      kelas: 1,
      headers: ['thumbnail', 'judul', 'mata pelajaran', 'duration'],
      rows: [],
      materials: [],
      selectedRow: null
    }
  },
  methods: {
    createMaterial: function () {
      var modulId = this.$route.query.modul_id
      this.$router.push({path: '/video/form', query: {modul_id: modulId}})
    },
    editMaterial: function () {
      var modulId = this.selectedRow.id
      // console.log(modulId)
      this.$router.push({path: '/video/material/form', query: {id: modulId, module: this.$route.query.modul_id}})
    },
    filterRow: function () {
      this.rows = []
      var context = this
      this.materials.forEach(function (material) {
        material.grades.forEach(function (grade) {
           if (grade.grade == context.kelas) {
             var duration = Moment.duration(material.duration, 'seconds')
             var hours =  duration.hours() < 10 ? '0'+ duration.hours() : duration.hours()
             var minutes = duration.minutes() < 10 ? '0'+ duration.minutes() : duration.minutes()
             var seconds = duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds()  
             var durationString = hours + ':' + minutes + ':' + seconds
             var data = {
               id: material.id,
               url: material.youtube_url,
               data: ["<img src='"+material.thumbnail+"' class='width-100'>", material.title, material.mapel.nama, durationString]
             }

             context.rows.push(data)
             console.log(context.rows)
             return
           }
        })
      })
    },
    deleteItem: function (data) {
      var confirmed = window.confirm('Apakah anda yakin akan menghapus video ini?')
      if (confirmed) {
        var context = this
        VideoService.deleteVideo(data.id, function (response) {
          if (response.success) {
            var foundIndex = context.rows.findIndex(function (row) {
              return row.id == data.id
            })

            context.rows.splice(foundIndex, 1)
          }
        })
      }
    }
  },
  watch: {
    kelas: function (newVal) {
      this.filterRow()
    }
  },
  mounted: function () {
    if (this.$route.query.modul_id) {
      var modulId = this.$route.query.modul_id
      var context = this
      VideoService.getListVideoByModuleId(modulId, function (response) {
        if (response.success) {
          response.data.forEach(function (data) {
            context.materials.push(data)
          })

          context.filterRow()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModulBelajarMaterial.vue?ee7b6f42